import { DIMENSION_TITLES, MEASURE_TITLES } from '../analytics'
import { MEASURE_DEFINITION_BY_TITLE } from '../analyticsDefinitions'
import { EXPLORER_TYPE, CHART_TYPE } from '../renderTypes'
import { FilterOperator } from '~/types/cube'
import { SourceType } from '~/types/sources'
import { DashboardModuleType, type DashboardConfig } from '~/types/dashboards'

export const createFunnelDashboardConfig = (): DashboardConfig => {
  return [
    {
      titleKey: 'dashboard.funnel.funnelMetrics',
      content: [
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.jobs.countHire.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_COUNT_HIRE,
                dimension: DIMENSION_TITLES.JOB_DEPARTMENT,
                type: EXPLORER_TYPE.BAR
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_COUNT_HIRE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_COUNT_HIRE]
            }
          }
        },
        {
          moduleType: DashboardModuleType.LARGE_CHART,
          options: {
            config: {
              titleKey: 'dashboard.funnel.stageConversionFunnel.title',
              infoContent: {
                definition:
                  'dashboard.funnel.stageConversionFunnel.info.definition',
                source: SourceType.ATS,
                insight: 'dashboard.funnel.stageConversionFunnel.info.insight'
              }
            },
            query: {
              measures: [
                MEASURE_TITLES.RECRUITMENT_COUNT_APPLIED_TERMINATED,
                MEASURE_TITLES.RECRUITMENT_COUNT_SCREENED_TERMINATED,
                MEASURE_TITLES.RECRUITMENT_COUNT_INTERVIEWED_1_TERMINATED,
                MEASURE_TITLES.RECRUITMENT_COUNT_INTERVIEWED_2_TERMINATED,
                MEASURE_TITLES.RECRUITMENT_COUNT_INTERVIEWED_3_TERMINATED,
                MEASURE_TITLES.RECRUITMENT_COUNT_INTERVIEWED_4_TERMINATED,
                MEASURE_TITLES.RECRUITMENT_COUNT_OFFERED_TERMINATED,
                MEASURE_TITLES.RECRUITMENT_COUNT_HIRED_TERMINATED
              ]
            },
            chartType: CHART_TYPE.FUNNEL
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.funnel.globalAcceptanceRate.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_GLOBAL_ACCEPTANCE_RATE,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_GLOBAL_ACCEPTANCE_RATE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_GLOBAL_ACCEPTANCE_RATE]
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.funnel.offerAcceptanceRate.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_OFFER_ACCEPTANCE_RATE,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_OFFER_ACCEPTANCE_RATE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_OFFER_ACCEPTANCE_RATE]
            }
          }
        }
      ]
    },
    {
      titleKey: 'dashboard.funnel.rejectionMetrics',
      content: [
        {
          moduleType: DashboardModuleType.DISTRIBUTION,
          options: {
            config: {
              titleKey: 'dashboard.funnel.interviewRejectionReasons.title',
              exploreLink: {
                measure:
                  MEASURE_TITLES.RECRUITMENT_COUNT_BEFORE_OFFER_REJECTED_TERMINATED,
                dimension: DIMENSION_TITLES.JOB_APPLICATION_REJECTION_REASON,
                type: EXPLORER_TYPE.DOUGHNUT
              },
              infoContent: {
                definition:
                  'dashboard.funnel.interviewRejectionReasons.info.definition',
                source: SourceType.ATS,
                insight:
                  'dashboard.funnel.interviewRejectionReasons.info.insight'
              }
            },
            query: {
              measures: [
                MEASURE_TITLES.RECRUITMENT_COUNT_BEFORE_OFFER_REJECTED_TERMINATED
              ],
              dimensions: [DIMENSION_TITLES.JOB_APPLICATION_REJECTION_REASON],
              filters: [
                {
                  member: DIMENSION_TITLES.JOB_APPLICATION_REJECTION_REASON,
                  operator: FilterOperator.SET,
                  values: []
                }
              ],
              limit: 5
            }
          }
        },
        {
          moduleType: DashboardModuleType.DISTRIBUTION,
          options: {
            config: {
              titleKey: 'dashboard.funnel.offerRejectionReasons.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_COUNT_REJECTED_OFFER,
                dimension: DIMENSION_TITLES.JOB_APPLICATION_REJECTION_REASON,
                type: EXPLORER_TYPE.DOUGHNUT
              },
              infoContent: {
                definition:
                  'dashboard.funnel.offerRejectionReasons.info.definition',
                source: SourceType.ATS,
                insight: 'dashboard.funnel.offerRejectionReasons.info.insight'
              }
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_COUNT_REJECTED_OFFER],
              dimensions: [DIMENSION_TITLES.JOB_APPLICATION_REJECTION_REASON],
              filters: [
                {
                  member: DIMENSION_TITLES.JOB_APPLICATION_REJECTION_REASON,
                  operator: FilterOperator.SET,
                  values: []
                }
              ],
              limit: 5
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.funnel.globalRejectionRate.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_GLOBAL_REJECTION_RATE,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_GLOBAL_REJECTION_RATE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_GLOBAL_REJECTION_RATE]
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.funnel.withdrawalRate.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_WITHDRAWAL_RATE,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_WITHDRAWAL_RATE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_WITHDRAWAL_RATE]
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.funnel.offerRejectionRate.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_OFFER_REJECTION_RATE,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_OFFER_REJECTION_RATE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_OFFER_REJECTION_RATE]
            }
          }
        }
      ]
    }
  ]
}
